import { onMounted } from  'vue';

import useObjectHelpers from './helpers/useObjectHelpers';

const useInitialData = ({ stateToMerge, initialData }) => {
  const { merge } = useObjectHelpers();

  onMounted(() => {
    merge(stateToMerge.form, initialData);
    stateToMerge.contractRequestUuid = initialData.contractRequestUuid;
  });
};

export default useInitialData;
